import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

export const StyledTitle = styled(Typography)`
    font-weight: bold;
    text-align: left;
`;
